<template>
  <router-link :class="departmentClass" :to="path">{{
    file.referencelong
  }}</router-link>
</template>

<script>
export default {
  name: "File",
  props: ["file", "bookmark"],
  computed: {
    departmentClass() {
      return this.file.department
        ? `department${this.file.department.id}`
        : `department0`;
    },
    modifiedHash() {
      return this.bookmark ? `#${this.bookmark}` : "#fileHeader";
    },
    path() {
      return {
        name: "file",
        hash: this.modifiedHash,
        params: { id: this.file.id }
      };
    }
  }
};
</script>
